import { getSessionUser } from './getSessionUser'
import { getDefaultLoggedOutSalesOrg } from '@insight/toolkit-utils'
import { v4 as uuid } from 'uuid'
import axios from 'axios'
export const getLWSearch = async () => {
  /**
   * Normalizes redirect keywords data structure
   * @param {Object} redirectKeywordsData - Raw redirect keywords data from API
   * @returns {Object} Normalized object with redirectURLs and keywords
   */
  function normalizeRedirectKeywords(redirectKeywordsData) {
    if (!redirectKeywordsData || typeof redirectKeywordsData !== 'object') {
      console.warn('Invalid redirect keywords data provided to normalizeRedirectKeywords')
      return {
        redirectURLs: {},
        keywords: {},
      }
    }
    const normalizedData = {
      redirectURLs: {},
      keywords: {},
    }
  
    return Object.keys(redirectKeywordsData).reduce((accumulator, keywordString) => {
      const redirectData = redirectKeywordsData[keywordString]
      if (!redirectData || !redirectData.redirectUrl) {
        console.warn(`Invalid redirect data for keywords: ${keywordString}`)
        return accumulator
      }
      const redirectURLGUID = uuid()
      const keywordsList = keywordString.split(';').map(keyword => keyword.trim().toLowerCase()).filter(Boolean)
      accumulator.redirectURLs[redirectURLGUID] = redirectData.redirectUrl
      keywordsList.forEach(keyword => {
        if (keyword) { 
          accumulator.keywords[keyword] = redirectURLGUID
        }
      })
  
      return accumulator
    }, normalizedData)
  }
  try {
    const { userInformation, locale, isLoggedIn, isIpsLogo } = await getSessionUser()
    const salesOrg = userInformation?.salesOrg || getDefaultLoggedOutSalesOrg(locale, isIpsLogo)
    const country = locale?.split('_')[1]
    const countryCode = (country === 'GB' || country === 'gb') ? 'UK' : country
    
    if (!countryCode || !locale) {
      throw new Error('Missing required parameters: countryCode or locale')
    }
    const redirectKeywordsURL = `/gapi/product-search/redirect-mapping?country=${encodeURIComponent(countryCode)}&locale=${encodeURIComponent(locale)}&login=${isLoggedIn}&salesOrg=${encodeURIComponent(salesOrg)}`
    
    const response = await axios.get(redirectKeywordsURL)

    if (!response?.data?.RedirectKeywords) {
      return {
        redirectURLs: {},
        keywords: {},
      }
    }
    
    return normalizeRedirectKeywords(response.data.RedirectKeywords)
  } catch (error) {
    console.error('Error getting redirect rules:', error)
    return {
      redirectURLs: {},
      keywords: {},
    }
  }
}

export default getLWSearch
